// Persists the most recently saved monogram selection so it can seed the
// initial state of the next new monogram the shopper configures. Only the
// `selection` shape ({ type, values, styleId, colorId, placementId }) is
// stored; the default-recovery effects in <MonogramContent /> gracefully fall
// back to the first available option when a stored id isn't offered for the
// current product.

const STORAGE_KEY = "monogram-default-selection";

/**
 * @returns {object|null} the last saved selection, or null when none is stored
 *   or storage is unavailable.
 */
export function loadMonogramDefault() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

/**
 * @param {object} selection the selection to remember as the default.
 */
export function saveMonogramDefault(selection) {
  if (!selection) return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
  } catch {
    // Ignore write failures (private mode, quota) — defaulting is best-effort.
  }
}
